import DestinationData from "./DestinationData"
import "./DestinationStyles.css"
import pyramid1 from '../assets/images/pyramid1.jpg'
import pyramid2 from '../assets/images/pyramid2.jpg'
import mars1 from '../assets/images/mars1.jpg'
import mars2 from '../assets/images/mars2.jpeg'

const Destination = () => {
    return (
        <div className="destination">
            <h1>Explore</h1>
            <p>Here are some popular sites for . Start exploring a new experience with learning</p>

            <DestinationData heading="Pyramids of Giza, Egypt"
                para="The Pyramids of Giza are among the most iconic and enduring monuments of ancient Egypt. Located on the outskirts of Cairo, these colossal structures were built over 4,500 years ago as tombs for the pharaohs Khufu, Khafre, and Menkaure. The largest of the three, the Great Pyramid of Khufu, stands as one of the Seven Wonders of the Ancient World and is a testament to the engineering prowess of the ancient Egyptians. These pyramids, constructed with massive limestone blocks, continue to captivate the imagination of people worldwide, serving as a testament to the rich cultural heritage and advanced architectural techniques of ancient Egypt."
                img1={pyramid1}
                img2={pyramid2} />

            <DestinationData heading="Mars, The red planet"
                para="Mars, the fourth planet from the Sun, is often called the Red Planetdue to its rusty-red appearance. It's a terrestrial planet with a thin atmosphere primarily composed of carbon dioxide. Mars features striking surface features, including vast plains, towering volcanoes, deep valleys, and polar ice caps. The planet has long fascinated scientists and explorers due to the possibility of past or present life and its potential as a future destination for human exploration and colonization. Numerous robotic missions, including rovers and orbiters, have been sent to study Mars, shedding light on its geology, climate history, and potential for habitability."
                img1={mars1}
                img2={mars2} />

        </div>
    )
}

export default Destination